import { type ReactNode } from 'react';
import { Warning, Heading } from '@hungryroot/ui-kit';
import styles from './WarningText.module.css';

export enum WarningTextStyleVariant {
  Critical = 'critical',
  Moderate = 'moderate',
}
interface Props {
  testid?: string;
  children: ReactNode;
  intensity?: WarningTextStyleVariant;
}

export function WarningText(props: Props) {
  const { testid, children, intensity = 'critical' } = props;

  return (
    <div
      data-testid={testid}
      className={`${styles.container} ${styles[intensity]}`}
    >
      <div className={styles['warning-icon-container']}>
        <Warning />
      </div>
      <Heading variant="H6">{children}</Heading>
    </div>
  );
}
